<!-- 这个组件使用 vue options api， 请不要使用 composition api -->
<script>
import emitter, { events } from '@/event-bus'
export default {
  name: 'SystemCard',
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    isPopover: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showExpand: false,
      hasExpand: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkContentHeight()
    })
  },
  methods: {
    onShowSystemRenevalDialog() {
      emitter.emit(events.showSystemRenewalDialog, { code: 'reneval' })
    },
    checkContentHeight() {
      const textEl = this.$refs.textRef
      if (textEl) {
        const lineHeight = parseInt(window.getComputedStyle(textEl).lineHeight)
        const totalHeight = textEl.scrollHeight

        // 判断是否超过两行
        this.hasExpand = totalHeight > lineHeight * 2
        this.showExpand = this.isPopover ? totalHeight > lineHeight * 2 : false
      }
    },
    handleExpand() {
      this.showExpand = false
    },
    handleFold() {
      this.showExpand = true
    },
  },
}
</script>

<template>
  <div class="message-notify-system-card" :class="{ 'is-small': isSmall, 'show-fold': hasExpand && !showExpand && !message.attachUrl }">
    <div class="time">
      {{ message.createTime }}
    </div>
    <div v-if="message.operateName" class="title">
      {{ message.operateName }}
    </div>
    <div ref="contentRef" class="content">
      <div ref="textRef" class="text" :class="{ 'text-overflow': showExpand }">
        {{ message.content }}
      </div>
      <div v-if="hasExpand && showExpand" class="expand-btn" @click="handleExpand">
        <div class="dot">
          ...
        </div>展开
      </div>
      <div v-if="hasExpand && !showExpand" class="expand-btn fold" @click="handleFold">
        收起
      </div>
    </div>
    <a v-if="message.attachUrl" class="attach-btn" :href="message.attachUrl" target="_blank">查看附件 ></a>

    <button
      v-if="message.feedConfigId === 69" class="opera-btn button-gradient"
      :data-ph-capture-attribute-page-actions="$getPosthogPath(['立即联系'])" @click="onShowSystemRenevalDialog"
    >
      立即联系
    </button>
  </div>
</template>

<style lang="scss">
.message-notify-system-card {
  padding: 12px;
  background: #FFFFFF;
  border-radius: 8px 8px 8px 8px;

  .opera-btn {
    margin-top: 8px;
  }

  &.is-small {
    .opera-btn {
      margin-top: 4px;
      padding: 3px 6px;
      font-size: 12px;
    }
  }

  &.show-fold {
    padding-bottom: 26px;
  }

  .time {
    font-size: 12px;
    color: #8FA1B2;
  }

  .title {
    margin-top: 4px;
    font-size: 14px;
    line-height: 18px;
    color: #242F57;
    font-weight: 500;
  }

  .content {
    position: relative;
    margin-top: 6px;

    .text {
      font-size: 12px;
      color: #8FA1B2;
      line-height: 1.5;
      white-space: pre-wrap;
    }

    .text-overflow {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .expand-btn {
      position: absolute;
      right: 0;
      bottom: 0;
      font-size: 12px;
      color: #717F8C;
      background: #fff;
      padding-left: 4px;
      cursor: pointer;

      .dot {
        color: #8FA1B2;
        vertical-align: bottom;
        display: inline-block;
      }

      &:hover {
        color: #4050FF;
      }

      &.fold {
        bottom: -16px;
      }
    }

  }

  .attach-btn {
    font-size: 12px;
    margin-top: 6px;
    color: #4050FF;
    position: relative;
    border: 1px solid transparent;
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 1px;
      background-color: #425AFF;
      left: 0;
      bottom: 0;
      transition: width .3s cubic-bezier(.165,.84,.44,1);
    }
    &:hover {
      &::after {
        width: 100%;
      }
    }
  }
}
</style>
